module.exports = __webpack_public_path__ + "static/media/pong-mobile.533f3f26.png";